module.exports = __webpack_public_path__ + "img/roles-fill.1ad2a3a6.svg";